import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PrizeService {
  url: string = environment.api.endpoint;

  constructor(private http: HttpClient) { }

  public getAllByOutingIteration(filter: any): any{
    return this.http.get(`${this.url}/prizes/iteration/${filter.outingIterationId}`, { params: filter });
  }

  public getById(id: string): any{
    return this.http.get(`${this.url}/prize/${id}`);
  }

  public create(data: any): any{
    return this.http.post(`${this.url}/prize/create`, data);
  }

  public update(id: string, data: any): any{
    return this.http.put(`${this.url}/prize/${id}`, data)
  }

  public delete(id: string, data: any): any{
    return this.http.post(`${this.url}/prize/delete/${id}`, data);
  }
}
